var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEstoniaFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 85.629",
    enableBackground: "new 0 0 122.88 85.629",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M6.966,0.239h108.948c3.7,0,6.728,3.027,6.728,6.727v71.696 c0,3.7-3.027,6.728-6.728,6.728H6.966c-3.699,0-6.727-3.027-6.727-6.728V6.966C0.239,3.266,3.267,0.239,6.966,0.239L6.966,0.239z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.966,0.239h108.948c3.7,0,6.728,3.027,6.728,6.727v50.307H0.239V6.966 C0.239,3.266,3.267,0.239,6.966,0.239L6.966,0.239z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0072CE",
    d: "M6.966,0.239h108.948c3.7,0,6.728,3.027,6.728,6.727v21.39H0.239 V6.966C0.239,3.266,3.267,0.239,6.966,0.239L6.966,0.239z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCCCCC",
    d: "M6.966,0h108.948c1.915,0,3.656,0.784,4.919,2.046c1.264,1.264,2.047,3.005,2.047,4.92v71.696 c0,1.915-0.783,3.657-2.046,4.92c-1.264,1.263-3.005,2.047-4.92,2.047H6.966c-1.914,0-3.656-0.784-4.919-2.047 C0.784,82.32,0,80.578,0,78.662V6.966c0-1.916,0.784-3.658,2.046-4.92C3.31,0.784,5.052,0,6.966,0L6.966,0z M115.914,0.479H6.966 c-1.784,0-3.406,0.729-4.581,1.905C1.209,3.56,0.479,5.183,0.479,6.966v71.696c0,1.784,0.73,3.406,1.906,4.582 c1.175,1.177,2.797,1.906,4.581,1.906h108.948c1.784,0,3.406-0.73,4.582-1.905c1.176-1.176,1.906-2.799,1.906-4.583V6.966 c0-1.784-0.73-3.407-1.906-4.583S117.698,0.479,115.914,0.479L115.914,0.479z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstoniaFlag);
export default __webpack_public_path__ + "static/media/estoniaFlag.c31ab38aeef5117bcdff29c86bc6878b.svg";
export { ForwardRef as ReactComponent };